import PropTypes from 'prop-types'
import { useState } from 'react'
import styled from 'styled-components'
import { Popover, ArrowContainer } from 'react-tiny-popover'

import { Box, Icon, theme } from '@redriverpress/system'

/* This component should likely be made into a common component for popovers,
 * with the ability to pass in both a button and popover content. I'll do that
 * when I have time, which will be after TESOL 2020 (maybe ha ha). If you need
 * a popover/tooltip component, please talk to me before duplicating this one.
 * Thanks!
 * -Cole
 */

const Button = styled.button`
  appearance: none;
  background: transparent;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  line-height: 1;
  height: 2.5rem;
  width: 2.5rem;

  &:hover,
  &:focus {
    outline: none;

    & ${Box} {
      background: ${props => props.theme.colors.yellow400};
    }
  }
`
Button.displayName = 'TooltipButton'

function ContentBody({ content }) {
  return (
    <Box bg='white' p={3} borderRadius='rounded'>
      {content}
    </Box>
  )
}

ContentBody.propTypes = {
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
}

function ClickableTootip({ content, icon }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Popover
      isOpen={isOpen}
      onClickOutside={() => setIsOpen(false)}
      positions={['bottom', 'top']}
      align='end'
      containerStyle={{ overflow: 'visible', zIndex: 3 }}
      padding={0}
      content={({ position, popoverRect, childRect }) => (
        <ArrowContainer
          position={position}
          popoverRect={popoverRect}
          childRect={childRect}
          arrowSize={8}
          arrowColor='white'
          style={{
            filter: theme.dropShadows[2],
            maxWidth: '300px',
          }}
        >
          <ContentBody content={content} />
        </ArrowContainer>
      )}
    >
      <Button onClick={() => setIsOpen(prev => !prev)}>
        <Box
          as='span'
          bg='gray200'
          borderRadius='circular'
          display='inline-flex'
          flex='0 0 auto'
          alignItems='center'
          justifyContent='center'
          size='1.5rem'
          transition='background 0.15s linear'
        >
          {/* This is a very rare exception to us never going below font size 0 */}
          <Icon icon={icon} fontSize='0.75rem' weight='regular' />
        </Box>
      </Button>
    </Popover>
  )
}

ClickableTootip.propTypes = {
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  icon: PropTypes.string.isRequired,
}

export default ClickableTootip
